import { render, staticRenderFns } from "./ImportSpecialFee.vue?vue&type=template&id=5ba91d40&scoped=true"
import script from "./ImportSpecialFee.vue?vue&type=script&lang=js"
export * from "./ImportSpecialFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba91d40",
  null
  
)

export default component.exports